import { render, staticRenderFns } from "./CouponUsed.vue?vue&type=template&id=5a3d84d6&"
import script from "./CouponUsed.vue?vue&type=script&lang=ts&"
export * from "./CouponUsed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports